<template>
  <div class="bg-dark">
    <!-- Footer -->
    <footer class="text-light font-small ">
      <div class="page-footer text-center text-md-left">
        <div class="row">
          <div class="col-md-4 mt-5 center-middle pr-md-0">
            <i class="icon-futalis-vet-white" />
          </div>

          <div class="col-md-3 text-center pl-md-0 pr-md-0 ml-md-0 mt-4 font-footer-small">
            <h6 class="text-uppercase">kontakt</h6>

            <ul class="contact-info list-unstyled mt-3">
              <li>
                <a href="javascript:void(0)"
                  >Tel. +49(0)341 39 29 87 96</a
                >
              </li>
              <li>
                <a href="javascript:void(0)"
                  >Fax. +49(0)341 39 29 47 22</a
                >
              </li>
              <li>
                <a :href="'mailto:praxis@futalis.de'"
                  >praxis@futalis.de</a
                >
              </li>
            </ul>
          </div>

          <div class="col-md-3 pl-md-0 ml-md-0 pr-md-0 text-center mt-4">
            <!-- Links -->
            <h6 class="text-uppercase ">ausgegründet aus</h6>
            <div
              aria-label="Universität Leipzig"
              class="bg-white mt-3 clickable icon-leipzig-university"
              style="margin: auto;"
              @click="openLink('https://rationsberechnung.de/ueber-uns/', true)"
            />
          </div>

          <div
            class="col-md-2 text-center mt-4"
            @click="openLink('https://rationsberechnung.de/ueber-uns/', true)"
          >
            <h6 class="text-uppercase">geprüfte qualität</h6>

            <div class="d-inline-flex mt-3">
              <i class="icon-tuv" />
              <i class="icon-gmp ml-sm-2 ml-lg-4" />
              <i class="icon-trusted-shop ml-sm-2 ml-lg-4" />
            </div>
          </div>
        </div>

        <div class="row py-0 font-footer-small">
          <div class="text-center footer-bottom-links">
            <a
                href="javascript:void(0)"
                @click="
                  openLink(
                    !user.identity.id
                      ? 'https://rationsberechnung.de/kontakt/'
                      : '/configurator/interface_account/contact/',
                      true
                  )
                "
            >
              Kontakt
            </a>
            <a
                href="javascript:void(0)"
                @click="openLink('https://rationsberechnung.de/impressum/',true)"
            >
              Impressum
            </a>
            <a
                href="javascript:void(0)"
                @click="
                  openLink(
                    !user.identity.id
                      ? 'https://rationsberechnung.de/geschaeftsbedingungen/'
                      : '/partnerbestimmungen',
                      true
                  )
                "
            >
              Geschäftsbedingungen
            </a>
            <a
                href="javascript:void(0)"
                @click="
                !user.identity.id ?
                  openLink( 'https://rationsberechnung.de/datenschutzerklaerung/',true) : openLink('/configurator/interface_account/datenschutz/')
                "
            >
              Datenschutzerklärung
            </a>
            <a href="#" onClick="UC_UI.showSecondLayer();">Cookie-Einstellung</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Footer',
  methods: {
    openLink: (uri,inNewTab = false) => {
      window.open(uri, inNewTab === true ? '_blank': '_self');
    }
  },
  computed: mapState({
    user: state => state.authModule.user
  })
};
</script>

<style lang="css" scoped>
.contact-info a{
  color: #c2c2c2;
}
.page-footer {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.footer-bottom-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}
.footer-bottom-links a {
  padding: 0.2em 2em;
  color: #c2c2c2 !important;
}

@media (max-width: 554px) {
  .text-right {
    display: block!important;
  }
  .text-right > a {
    text-align: center!important;
    display: block!important;
  }
}

@media (min-width: 576px) {
  .page-footer {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .page-footer {
    max-width: 760px;
  }
}

@media (min-width: 800px) {
  .page-footer {
    max-width: 780px;
  }
}

@media (min-width: 992px) {
  .page-footer {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .page-footer {
    max-width: 1140px;
  }
}
</style>
